import { render, staticRenderFns } from "./TruspayForm.vue?vue&type=template&id=0acbef65&scoped=true&"
import script from "./TruspayForm.vue?vue&type=script&lang=js&"
export * from "./TruspayForm.vue?vue&type=script&lang=js&"
import style0 from "./TruspayForm.vue?vue&type=style&index=0&id=0acbef65&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0acbef65",
  null
  
)

export default component.exports